import { Author } from 'types/author';

export const mockGetAuthorInfoResponse: Author = {
  userId: 1,
  nickname: 'アクセル',
  icon: 'https://disneyparkstory.com/wp-content/uploads/2017/09/apple-touch-icon.png',
  url: 'https://disneyparkstory.com',
};
